import { config } from "@/lib/constants";
const padToTwoDigits = (value) => String(value).padStart(2, "0");

const toIsoDateString = (date) =>
  `${date.getFullYear()}-${padToTwoDigits(date.getMonth() + 1)}-${padToTwoDigits(date.getDate())}`;

export const addYearsMinusOneDay = (iso, years) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  date.setFullYear(date.getFullYear() + years);
  date.setDate(date.getDate() - 1);
  return toIsoDateString(date);
};

export const toDateInput = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);
};

export const normalizeNxmapFormValue = (key, value) => {
  if (value === null || typeof value === "undefined") return "";
  if (
    key === "baseYearStart" ||
    key === "baseYearEnd" ||
    key === "reportingPeriodStart" ||
    key === "reportingPeriodEnd"
  )
    return toDateInput(value);
  if (key === "baseYear" || key === "threshold" || key === "reportingYear")
    return String(value);
  return value;
};

export const getBaseYearStartDate = (baseYear) => {
  if (!baseYear) return "";
  return `${baseYear}-01-01`;
};

export const getBaseYearEndBounds = (baseYearStart, baseYearStartDate) => {
  const startSource = baseYearStart || baseYearStartDate;
  if (!startSource) return { min: "", max: "" };
  const min = toDateInput(addYearsMinusOneDay(startSource, 1));
  const max = toDateInput(addYearsMinusOneDay(startSource, 3));
  return { min, max };
};

export const getReportYearStartDate = (reportingYear) => {
  if (!reportingYear) return "";
  return `${reportingYear}-01-01`;
};

export const getReportYearEndBounds = (
  reportingPeriodStart,
  reportYearStartDate,
) => {
  const startSource = reportingPeriodStart || reportYearStartDate;
  if (!startSource) return { min: "", max: "" };
  const min = toDateInput(addYearsMinusOneDay(startSource, 1));
  const max = toDateInput(addYearsMinusOneDay(startSource, 3));
  return { min, max };
};

const formatDateDisplay = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const getBaseYearStartHelperText = (baseYearStartDate) => {
  if (!baseYearStartDate)
    return "Select the start date of your base year period.";
  return `Default start date is ${formatDateDisplay(baseYearStartDate)}. Adjust if needed.`;
};

export const getBaseYearEndHelperText = (bounds) => {
  if (!bounds?.min || !bounds?.max) {
    return "Select the end date of your base year period.";
  }
  return `Select an end date between ${formatDateDisplay(bounds.min)} and ${formatDateDisplay(bounds.max)}.`;
};

export const getReportYearStartHelperText = (reportYearStartDate) => {
  if (!reportYearStartDate)
    return "Select the start date of your report year period.";
  return `Default start date is ${formatDateDisplay(reportYearStartDate)}. Adjust if needed.`;
};

export const getReportYearEndHelperText = (bounds) => {
  if (!bounds?.min || !bounds?.max) {
    return "Select the end date of your report year period.";
  }
  return `Select an end date between ${formatDateDisplay(bounds.min)} and ${formatDateDisplay(bounds.max)}.`;
};
export const getLabel = (key, list) => {
  if (!key) return "";
  return list?.find((l) => l.key === key)?.value;
};

export const toDateOnly = (dateStr) => {
  if (!dateStr) return "";
  try {
    return new Date(dateStr).toISOString().split("T")[0];
  } catch {
    return dateStr;
  }
};

export const visitProject = (projectName = null) => {
  // const base = String(API_URL || "").replace(/\/$/, "");
  // const ver = String(API_VERSION || "v1").replace(/^\/+|\/+$/g, "");
  const redirectPath = "/"; // change to deep-link if needed
  const ssoVisitUrl = `${config.apiUrl}/visit/${projectName}?redirect=${encodeURIComponent(redirectPath)}`;
  window.open(ssoVisitUrl, "_blank", "noopener,noreferrer");
  return;
};

export const GHG_REPORT_PURPOSE = [
  { key: "compliance", value: "Compliance" },
  { key: "internal_reporting", value: "Internal Reporting" },
  { key: "stakeholders_requirement", value: "Stakeholders' Requirement" },
];
